import { Box } from "@mui/material";
import { ChangeEvent, KeyboardEvent, useState } from "react";

import styles from "../styles";

interface Props {
  values: string[];
  selected: string[];
  onToggle: (v: string) => void;
  otherPlaceholder: string;
}

export function ChipsWithOther({
  values,
  selected,
  onToggle,
  otherPlaceholder,
}: Props) {
  const customs = selected.filter((s) => !values.includes(s));
  const [adding, setAdding] = useState(false);
  const [input, setInput] = useState("");

  const submit = () => {
    const v = input.trim();
    if (v.length > 0 && !selected.includes(v)) onToggle(v);
    setInput("");
    setAdding(false);
  };

  return (
    <Box sx={styles.chipsWrapper}>
      {values.map((v) => {
        const active = selected.includes(v);
        return (
          <Box
            key={v}
            component="button"
            type="button"
            onClick={() => onToggle(v)}
            sx={styles.chip(active)}
          >
            {active && (
              <Box
                component="i"
                className="fa-solid fa-circle-check"
                sx={styles.chipIconSmall}
              />
            )}
            {v}
          </Box>
        );
      })}
      {customs.map((v) => (
        <Box
          key={v}
          component="button"
          type="button"
          onClick={() => onToggle(v)}
          sx={styles.chip(true)}
        >
          {v}
          <Box
            component="i"
            className="fa-solid fa-xmark"
            sx={styles.chipIconSmall}
          />
        </Box>
      ))}
      {adding ? (
        <Box sx={styles.chipInputPill}>
          <Box
            component="input"
            autoFocus
            value={input}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setInput(e.target.value)
            }
            onBlur={submit}
            onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") submit();
              if (e.key === "Escape") {
                setInput("");
                setAdding(false);
              }
            }}
            placeholder={otherPlaceholder}
            sx={styles.chipInput}
          />
        </Box>
      ) : (
        <Box
          component="button"
          type="button"
          onClick={() => setAdding(true)}
          sx={styles.chipAddButton}
        >
          <Box
            component="i"
            className="fa-solid fa-plus"
            sx={styles.chipPlusIcon}
          />
          Other
        </Box>
      )}
    </Box>
  );
}
